/**
 * YLI GA4 Banner CTA Tracking
 * Version: 1.0.0
 * Created: 2026-01-14
 * Purpose: Track banner/hero CTA clicks across all banner sections
 * GA4 Events: banner_cta_click, banner_view
 * Spec: docs/ga4-events/ga4-event-tracking-plan.md
 *
 * Tracks CTAs in:
 * - section-hero.liquid (Image Banner)
 * - yli-section-image-with-text.liquid (YLI: Image with Text)
 * - section-hero-video.liquid
 * - section-hero-scrolling.liquid
 */

(function() {
  'use strict';

  var viewedBanners = new Set();

  // GA4 Event: banner_cta_click
  // Track CTA button clicks in banner/hero sections
  function trackBannerCTAClick() {
    document.addEventListener('click', function(e) {
      // Look for CTA buttons in hero/banner sections
      var ctaButton = e.target.closest('.hero__button .btn, .image-with-text__button .btn, [data-hero-cta]');
      if (!ctaButton) return;

      // Get banner/section context
      var section = ctaButton.closest('[data-section-type], [class*="hero"], [class*="image-with-text"]');
      if (!section) return;

      var ctaText = ctaButton.textContent.trim();
      var destinationUrl = ctaButton.getAttribute('href') || '';

      // Determine section type
      var sectionType = 'unknown';
      if (section.hasAttribute('data-section-type')) {
        sectionType = section.getAttribute('data-section-type');
      } else if (section.classList.contains('image-with-text')) {
        sectionType = 'image_with_text';
      } else if (section.className.includes('hero')) {
        sectionType = 'hero';
      }

      // Determine page context
      var pageType = 'unknown';
      var pageUrl = window.location.pathname;

      if (pageUrl === '/' || pageUrl === '/index') {
        pageType = 'homepage';
      } else if (pageUrl.includes('/pages/')) {
        pageType = 'page';
      } else if (pageUrl.includes('/collections/')) {
        pageType = 'collection';
      } else if (pageUrl.includes('/products/')) {
        pageType = 'product';
      }

      if (typeof gtag === 'function') {
        gtag('event', 'banner_cta_click', {
          'cta_text': ctaText,
          'destination_url': destinationUrl,
          'section_type': sectionType,
          'page_type': pageType,
          'page_url': pageUrl
        });
      }
    });
  }

  // GA4 Event: banner_view
  // Track when banners become visible (homepage hero banners only)
  function trackBannerView() {
    // Only track on homepage
    if (window.location.pathname !== '/' && window.location.pathname !== '/index') return;

    // Look for hero/banner sections
    var banners = document.querySelectorAll('[data-section-type*="hero"], .image-with-text, .text-promo');

    if (!banners.length) return;
    if (typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          var banner = entry.target;
          var sectionId = banner.getAttribute('data-section-id') || banner.id;

          // Only fire once per banner
          if (!viewedBanners.has(sectionId)) {
            viewedBanners.add(sectionId);

            var sectionType = banner.getAttribute('data-section-type') || 'unknown';
            var heading = banner.querySelector('.hero__title, .image-with-text__heading, h1, h2');
            var bannerHeading = heading ? heading.textContent.trim() : 'Unknown';

            if (typeof gtag === 'function') {
              gtag('event', 'banner_view', {
                'banner_heading': bannerHeading,
                'section_type': sectionType,
                'page_type': 'homepage'
              });
            }

            // Stop observing this banner
            observer.unobserve(banner);
          }
        }
      });
    }, {
      threshold: 0.5
    });

    // Observe all banners
    banners.forEach(function(banner) {
      observer.observe(banner);
    });
  }

  // Initialize tracking when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      trackBannerCTAClick();
      trackBannerView();
    });
  } else {
    trackBannerCTAClick();
    trackBannerView();
  }

})();
